/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import "./friendsCard.scss";
import DefaultHearder from "@/assets/icons/default-avatar.svg";
import UKImg from "@/components/UKImg";
import { useTranslation } from "@/i18n/client";

export default function FriendsCard({ data, status }: any) {
  const { t } = useTranslation();
  return (
    <div className="groupWrapItem">
      {data.avatar ? (
        <div className="avatar_img">
          <UKImg
            url={data.avatar}
            urlExtend={{
              imgKey: data.avatar ? data.avatar : "",
              width: 50,
              height: 50,
            }}
          />
        </div>
      ) : (
        <div className="avatar_img">
          <DefaultHearder className="headerIcon" />
        </div>
      )}

      <p className="name">{data.nickName}</p>
      <p className="result">{status === "SUCCESS" ? t("profile.inviteFriend.ordered") : t("profile.inviteFriend.registered")}</p>
      <p className="time">{data.actionTimeStr}</p>
    </div>
  );
}
